import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { findAJobPaths } from "../../../routes/find-a-job";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../../../redux/features/find-a-job/reducers/authReducer";

const FreeTrialModal = ({ onContinue, buttonText = "Go to Dashboard" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
      return;
    }
    dispatch(setIsFindAJobModal(false));
    dispatch(setRegisterStep(1));
    navigate(findAJobPaths.Dashboard);
  };

  return (
    <div>
      <section className="py-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 mx-auto text-center">
              <div className="ct_signup_logo mb-3">
                <img src="assets/img/Nuvio_logo.png" alt="" />
              </div>
              <h2 className="ct_fs_32 ct_fw_600 mb-3 ct_darkblue_text">
                Free Trial Activated
              </h2>
              <p className="ct_fs_16 ct_darkblue_text mb-4">
                Your one month free trial is active.
              </p>
              <button
                className="ct_yellow_btn ct_darkblue_btn ct_h_48 d-block mx-auto"
                type="button"
                onClick={handleContinue}
                style={{ minWidth: "220px" }}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FreeTrialModal;
